import { Form, Progress } from 'antd';
// import { useEffect } from 'react';

// let progress = 0;
const ProgressBar = ({ percent }) => {
    // const titleTh = Form.useWatch('titleTh', form);
    // const templateNameTh = Form.useWatch('templateNameTh', form);
    // const firstParagraphTh = Form.useWatch('firstParagraphTh', form);
    // const consents = Form.useWatch('consents', form);

    // useEffect(() => {
    //     if (titleTh) progress = 25;
    //     if (templateNameTh) progress = 25;
    //     if (firstParagraphTh) progress = 25;
    //     if (consents?.length > 0) progress = 25;
    //     if (titleTh && templateNameTh) progress = 50;
    //     if (templateNameTh && firstParagraphTh) progress = 50;
    //     if (titleTh && firstParagraphTh) progress = 50;
    //     if (titleTh && templateNameTh && firstParagraphTh) progress = 75;
    //     if (
    //         titleTh &&
    //         templateNameTh &&
    //         firstParagraphTh &&
    //         consents?.length > 0
    //     )
    //         progress = 100;
    // }, [titleTh, templateNameTh, firstParagraphTh, consents, form]);

    return (
        <Form.Item name="progress">
            <Progress
                percent={percent}
                className="my-2"
                showInfo={false}
                strokeColor={{ '0%': '#C2BAFF', '100%': '#7B67FB' }}
            />
        </Form.Item>
    );
};

export default ProgressBar;
